export default () => ({
  root: {},
  table: {
    
    '& th, td': {
      border: '1px solid #DFE3E8',
    }
  }
});
